"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledAnchorButton = exports.StyledLinkButton = exports.StyledButton = exports.StyledButtonElement = void 0;
const styled_1 = __importDefault(require("@emotion/styled"));
const is_prop_valid_1 = __importDefault(require("@emotion/is-prop-valid"));
const react_router_dom_1 = require("react-router-dom");
const merlin_theme_1 = __importDefault(require("@travelnest/merlin.theme"));
const loading_spinner_svg_1 = __importDefault(require("./loading-spinner.svg"));
const constants_1 = require("./constants");
const buttonHeight = '40px';
const background = (k) => (p) => {
    const v = p[k];
    const isImage = typeof v === 'string' && ((v.includes('.') || v.includes('/')) || v.includes('gradient'));
    return `background-${isImage ? 'image' : 'color'}: ${v};`;
};
const shouldForwardProp = (prop) => (0, is_prop_valid_1.default)(prop) && prop !== 'loading';
const StyledButtonElement = (component) => (0, styled_1.default)(component, { shouldForwardProp }) `
	${merlin_theme_1.default.typography.button};
	${background('bgColor')}
	color: ${props => props.color};
	display: inline-flex;
	align-items: center;
	justify-content: center;
	text-decoration: none;
	outline: none;
	position: relative;
	height: ${buttonHeight};
	border: none;
	border-radius: ${merlin_theme_1.default.layout.radius.squared};
	padding: ${merlin_theme_1.default.layout.spacing.smallest} ${merlin_theme_1.default.layout.spacing.standard};
	opacity: ${props => props.disabled ? 0.5 : 1};
	transition: background-color ${merlin_theme_1.default.motion.transition.default}, background-image ${merlin_theme_1.default.motion.transition.default};
	-moz-osx-font-smoothing: grayscale;
	-webkit-font-smoothing: antialiased;
	cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};
	white-space: nowrap;
	overflow: visible;
	line-height: initial;

	:hover {
		${background('hoverColor')}
	}

	:focus,
	:active {
		${background('activeColor')}
	}

	/*
	this produces the highlight outline on focus/active.
	the outline has a 1px clearance from the button itself, and tracks
	the shape of the button. this was best-achieved with a border on an
	:after which overlays the button and is 2px wider in all directions.
	the corner radii are also 2px longer to match button corner curves
	*/
	:after {
		content: '';
		display: block;
		position: absolute;
		top: -2px;
		bottom: -2px;
		right: -2px;
		left: -2px;
		border-radius: calc(2px + ${merlin_theme_1.default.layout.radius.squared});
		border: 1px solid ${merlin_theme_1.default.colours.highlight.default};
		opacity: 0;
		transition: opacity ${merlin_theme_1.default.motion.transition.default};
		-webkit-transition: opacity ${merlin_theme_1.default.motion.transition.default};
		pointer-events: none;
	}
	:focus:after,
	:active:after {
		opacity: 1;
	}

/* === Icon text === */

& .merlin-button__icon {
	font-family: 'TravelNest';
	display: inline-block;
}

& .merlin-button__icon--before {
	margin-right: ${merlin_theme_1.default.layout.spacing.smallest};
}

& .merlin-button__icon--after {
	margin-left: ${merlin_theme_1.default.layout.spacing.smallest};
}

/* === Loading === */

&.merlin-button--loading,
&.merlin-button--loading:active,
&.merlin-button--loading:focus,
&.merlin-button--loading:hover {
	background-color: ${(props) => props.bgColor || constants_1.presetThemes.Neutral.bgColor} !important;
	color: ${(props) => props.color || constants_1.presetThemes.Neutral.color} !important;
}

@keyframes button-loader-spin {
	from {
		transform: rotate(0deg);
	}

	to {
		transform: rotate(0deg);
	}
}

& > .merlin-button__loader {
	background-image: url(${loading_spinner_svg_1.default});
	background-size: contain;
	background-repeat: no-repeat;
	background-position: center center;
	transform: rotate(0deg);
	animation: button-loader-spin 1s linear;
	height: 85%;
	filter: grayscale(1);
	position: absolute;
	width: 100%;
	right: 0px;
	top: 10%;
}

& > .merlin-button__content--hidden {
	visibility: hidden;
}`;
exports.StyledButtonElement = StyledButtonElement;
exports.StyledButton = (0, exports.StyledButtonElement)('button');
exports.StyledLinkButton = (0, exports.StyledButtonElement)(react_router_dom_1.Link);
exports.StyledAnchorButton = (0, exports.StyledButtonElement)('a');
//# sourceMappingURL=button.styled.js.map